import React from 'react';
import PropTypes from 'prop-types';
import BaseComponent from "../../../gd-components/base-component/base-component";

import Checkbox from 'core/gd-components/checkbox/checkbox';

import Classes from 'classnames';
import _ from 'lodash';

export default class CompanyItem extends BaseComponent {
    static propTypes = {
        company: PropTypes.object,
        counter: PropTypes.number,
        expandable: PropTypes.bool,
        isHighlighted: PropTypes.bool,
        isSelected: PropTypes.bool,
        isExpanded: PropTypes.bool,
        showCompanyIcon: PropTypes.bool,
        noCollapseExpand: PropTypes.bool,
        multiselect: PropTypes.bool,
        multiselectCheckboxType: PropTypes.oneOf(['default','full-colored','filled']),
        multiselectCheckboxSize: PropTypes.oneOf(['normal','normal-14','small']),

        onClick: PropTypes.func,
        onToggleExpand: PropTypes.func
    };

    static defaultProps = {
        selectable: true,
        expandable: true,
        isExpanded: false,
        multiselect: false,
        multiselectCheckboxType: 'default',
        multiselectCheckboxSize: 'normal-14',
        level: 0
    };

    click = () => {
        this.onClick()
    }

    toggleExpand = () => {
        this.onArrowClick()
    }

    onClick = (e) => {
        if (e) e.stopPropagation()
        if (this.props.onClick) this.props.onClick(this.props.company.id)
    }

    onArrowClick = (e) => {
        if (e) e.stopPropagation()
        if (this.props.onToggleExpand) this.props.onToggleExpand("c_"+this.props.company.id)
    }

    renderCompanyIcon = () => {
        let res;
        if (this.props.showCompanyIcon) {
            res = <div className="gd-tree-item-icon company-icon i5-organization"> </div>
        }

        return res;
    };

    renderMultiselectCheckbox = () => {
        return (this.props.multiselect && this.props.selectable) &&
            <Checkbox className="gd-tree-check-box"
                      isChecked={this.props.isSelected}
                      size={this.props.multiselectCheckboxSize}
                      type={this.props.multiselectCheckboxType}/>;
    };

    renderCounter = () => {
        return !_.isNil(this.props.counter) && <div className="gd-tree-item-counter">{this.props.counter}</div>;
    };

    render() {
        const classes = Classes("gd-tree-item-company", this.props.className, {
            'gd-tree-item-selected': this.props.isSelected,
            "with-counter": !_.isNil(this.props.counter),
            'is-highlighted': this.props.isHighlighted,
        });

        const arrowClasses = Classes('gd-tree-item-arrow-icon',{
            "hidden": !this.props.expandable,
            "i5-big-angle-down": this.props.isExpanded,
            "i5-big-angle-right": !this.props.isExpanded
        });

        return (
            <div className={classes} onClick={this.onClick}>
                {this.renderMultiselectCheckbox()}
                {!this.props.noCollapseExpand && <div className={arrowClasses} onClick={this.onArrowClick}> </div>}
                <div className="gd-tree-item-name">{this.renderCompanyIcon()}{this.props.company.name}</div>
                {this.renderCounter()}
            </div>
        );
    }
}